import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { fetchPublicBlogPosts } from 'helpers/blog';

const LandingBlog = () => {
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const response = await fetchPublicBlogPosts();
        setPosts(response.posts || []);
      } catch (error) {
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  if (loading) {
    return (
      <div className="py-6 text-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!posts.length) {
    return null;
  }

  return (
    <section className="py-6 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="mb-2">{t('BLOG.LANDING_TITLE')}</h2>
          <p className="text-600 mb-0">{t('BLOG.LANDING_DESCRIPTION')}</p>
        </div>
        <Row className="g-4">
          {posts.map(post => (
            <Col lg={4} md={6} key={post.id}>
              <Card className="h-100 border">
                {post.cover_image_url ? (
                  <div style={{ height: '180px', backgroundImage: `url(${post.cover_image_url})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
                ) : (
                  <div style={{ height: '180px', background: `linear-gradient(135deg, ${post.accent_color || '#0b5ed7'}, #0b1727)` }} />
                )}
                <Card.Body>
                  <div className="text-500 fs--2 mb-2">
                    {[post.category, post.author_name || post.author?.full_name || 'Gestodo', post.reading_time].filter(Boolean).join(' · ')}
                  </div>
                  <h5 className="mb-3">{post.title}</h5>
                  {post.subtitle ? <p className="text-700 mb-2">{post.subtitle}</p> : null}
                  <p className="text-600 mb-0">{post.excerpt || t('BLOG.LANDING_FALLBACK')}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default LandingBlog;
